import React from 'react';
import { FormControl } from 'react-bootstrap';
import BzmIcon from '../../icons/BzmIcon';

type BzmSearchProps = {
  onChange: any;
  disabled?: boolean;
  value?: string;
  /** Ref to the search input field */
  searchRef?: any;
  placeholder?: string;
  tabIndex?: number;
  autoFocus?: boolean;
  id?: string;
};

/**
 * Bzm Search component with mark up from Blaze Bootstrap.
 * @param props
 * @constructor
 */
const BzmSearchInput = (props: BzmSearchProps) => {
  return (
    <div className="has-form-control-icon has-form-control-icon-left mb-3">
      <FormControl
        autoComplete={'off'}
        id={props.id}
        tabIndex={props.tabIndex}
        autoFocus={props.autoFocus && props.autoFocus === true ? true : undefined}
        ref={props.searchRef}
        style={{ width: '100%' }}
        value={props.value}
        onChange={(e: any) => props.onChange(e.target.value)}
        disabled={props.disabled}
        placeholder={props.placeholder}
      />
      <span className="form-control-icon form-control-icon-left">
        <BzmIcon variant={'icon-bzm-search'} className={'icon-theme-gray-50'}></BzmIcon>
        <span className="sr-only">Search</span>
      </span>
    </div>
  );
};

export default BzmSearchInput;
